import { render, staticRenderFns } from "./vehicleTrail.vue?vue&type=template&id=2a4b1056&scoped=true"
import script from "./vehicleTrail.vue?vue&type=script&lang=js"
export * from "./vehicleTrail.vue?vue&type=script&lang=js"
import style0 from "./vehicleTrail.vue?vue&type=style&index=0&id=2a4b1056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4b1056",
  null
  
)

export default component.exports